var isObjectLike = {};
export {
  isObjectLike as __exports
};
//# sourceMappingURL=isObjectLike.js.map
